import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { FormConfigService } from 'src/app/services/form-config.service';
import { NoValidatorError } from 'src/fieldFormControl/validators/ValidatorErrors';

export class VersementInitialMontantValidatorFactory {
  static getValidator(fieldKey: string, validatorKey: string, config: FormConfigService): ValidatorFn {
    switch (validatorKey) {
      case 'epargneBancaireRestanteMinimum':
        return epargneBancaireRestanteMinimum(fieldKey, validatorKey, config);
      case 'epargneFinanciaireRestanteMinimum':
        return epargneFinanciaireRestanteMinimum(fieldKey, validatorKey, config);
      default:
        throw new NoValidatorError(fieldKey, validatorKey);
    }
  }
}

export class VersementComplementaireMontantValidatorFactory {
  static getValidator(fieldKey: string, validatorKey: string, config: FormConfigService): ValidatorFn {
    switch (validatorKey) {
      case 'epargneBancaireRestanteMinimum':
        return epargneBancaireRestanteMinimum(fieldKey, validatorKey, config);
      case 'epargneFinanciaireRestanteMinimum':
        return epargneFinanciaireRestanteMinimum(fieldKey, validatorKey, config);
      default:
        throw new NoValidatorError(fieldKey, validatorKey);
    }
  }
}

export function epargneBancaireRestanteMinimum(
  fieldKey: string,
  validatorKey: string,
  config: FormConfigService
): ValidatorFn {
  const banqueEpargne = 15000; // FIXME: this should be calculated from the ficheConseil
  return epargneRestanteMinimumValidator(fieldKey, config, validatorKey, banqueEpargne);
}

export function epargneFinanciaireRestanteMinimum(
  fieldKey: string,
  validatorKey: string,
  config: FormConfigService
): ValidatorFn {
  const financeEpargne = 9999; // FIXME: this should be calculated from the ficheConseil
  return epargneRestanteMinimumValidator(fieldKey, config, validatorKey, financeEpargne);
}

function epargneRestanteMinimumValidator(
  fieldKey: string,
  config: FormConfigService,
  validatorKey: string,
  baseCalcul: number
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    // TODO: Validation disabled until connaissance client data is available.




    return null;
  };
}
